import BROWSER_STORAGE from "constants";
import { getUserPermissions } from "./browserStorage";

export const checkRoute = (route) => {
  const permissions = getUserPermissions();
  let permarray = [];
  if (permissions) {
    permarray = permissions.split(",");
  }

  if (route.permissions.length === 0) {
    return true;
  }
  let flag = false;
  route.permissions.forEach((permission) => {
    if (permarray.indexOf(permission) > -1) {
      flag = true;
    }
  });
  return flag;
};
